import React from "react";
import { useLocation } from "react-router-dom";

import styled from "styled-components/macro";

import {
  SectionContent,
  WrapperVerticalPadding,
  sidePadding,
} from "Payments/PaymentPage/PaymentFormScreen/styles";
import { useGetPaymentTypeVerbiage } from "Payments/PaymentPage/Shared/useGetPaymentTypeVerbiage";
import { motion } from "framer-motion";
import qs from "qs";

import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";

import { usePaymentPage } from "../../PaymentPageContext";

export default function ApplyPaymentToExistingPledgeSection() {
  const {
    state: {
      applyToExistingPledge,
      fund: { fundColorSafe },
    },
    dispatch,
  } = usePaymentPage();

  const { noun } = useGetPaymentTypeVerbiage();
  const campaign = window.data?.paymentPageData?.campaign?.title;
  const pledge = window.data?.paymentPageData?.campaign?.pledge;
  const hasExistingPledge =
    window?.data?.paymentPageData?.user?.hasExistingPledge;
  const location = useLocation();
  const { pledgeID: pledgeIDParam } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  const toggle = () => {
    dispatch({
      type: "toggleApplyToExistingPledge",
    });
  };

  if (pledgeIDParam || !pledge || !hasExistingPledge) return null;

  return (
    <Wrapper>
      <Content>
        <FnrCheckbox
          on={applyToExistingPledge}
          toggleOn={toggle}
          color={fundColorSafe}
        >
          Apply this {noun} to {campaign}
        </FnrCheckbox>
      </Content>
      <WrapperVerticalPadding />
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  ${sidePadding}
  overflow: hidden;
`;
const Content = styled(SectionContent)`
  padding-top: 0;
  padding-bottom: 0;
  background: transparent;
  box-shadow: none;
  font-weight: 400;
`;
